import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Arrow from '../../assets/right-arrow-long.inline.svg';
import GatsbyImage from 'gatsby-image';

const Holder = styled.div.attrs( {
  className: 'card',
} )`
  a {
    > :first-child { margin-top: 0; }
    > :last-child { margin-bottom: 0; }
    .readmore {
      display: flex;
      align-items: center;
      font-style: italic;
      svg {
        height: 0.5rem;
        width: auto;
        margin-left: 0.5rem;
        margin-top: 0.2rem;
        transition: transform 0.25s;
      }
    }
    &:hover .readmore svg { transform: translateX(0.2rem); }
  }
`;

const ImageHolder = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  margin-bottom: 2rem;
`;

function Card( props ) {
  return (
    <Holder>
      <Link to={props.to}>
        <ImageHolder>
          <GatsbyImage
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: '0',
              left: '0',
            }}
            fluid={props.image.fluid}/>
        </ImageHolder>
        <h2 className="h4">{props.title}</h2>
        <p>{props.excerpt}</p>
        <p className="readmore"><span>Read more</span><Arrow/></p>
      </Link>
    </Holder>
  )
}

Card.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default Card;
